module.exports = __webpack_public_path__ + "static/media/metalab-restorations@2x.26062755.png";